import React from 'react';
import { Text, View } from 'react-native-web';
import {
  Android,
  Change_ID,
  credit_card_8696,
  Password_is_incorrect,
} from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import ShortInputTextComponent from '../../AuxiliaryComponent/InputTextComponent/ShortInputTextComponent';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import TextLink_9_3 from '../../AuxiliaryComponent/TextComponent/TextLink_9_3';
import { getBoldFont } from '../../../../utils/Utils';

//= ========================================================================
const UserNameAndPassFP = ({
  globJSON,
  simPlatform,
  notSkipped,
  TopTitle,
  withoutChangeIdStr,
  UserNameHint,
  passwordInputText,
  borderColor,
  erroMessage,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { auth } = globJSON.configurations.launch;
  const myStyles = {
    btnContainer: {
      marginTop: 20,
    },
    linkContainer: {
      marginLeft: 42,
      paddingVertical: 3,
      marginBottom: 11,
    },
    opacityStyle: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
    errorMessageStyle: {
      marginTop: 3,
      marginLeft: 42,
      fontFamily: `${getBoldFont(globJSON, simPlatform)}`,
      fontSize: 8.1,
      color: colors.negative_color,
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={auth.enter_credentials}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
    >
      <ShortInputTextComponent
        globJSON={globJSON}
        inputText={UserNameHint || credit_card_8696}
        whiteBackground
        withPrimaryColor={!UserNameHint}
      />

      <View style={myStyles.linkContainer}>
        {!withoutChangeIdStr
                && (
                <TextLink_9_3
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  withOutAlign
                >
                  {Change_ID}
                </TextLink_9_3>
                )}
      </View>

      <ShortInputTextComponent
        globJSON={globJSON}
        inputText={passwordInputText || auth.password}
        whiteBackground
        borderColor={borderColor}
        withPrimaryColor={borderColor}
      />
      {erroMessage && (
        <Text style={myStyles.errorMessageStyle}>
          {Password_is_incorrect}
        </Text>
      )}
      <View style={myStyles.btnContainer}>
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          inputText={auth.approve}
          shortBtn
          disableBtn
        />
      </View>

      {!notSkipped && <View style={myStyles.opacityStyle} />}
    </FullPageSimulator>
  );
};

export default UserNameAndPassFP;
